import React from 'react'
import { styled } from 'styled-components'
import { observer } from 'mobx-react'
import { useTranslation } from 'react-i18next'
import { useStore } from 'todistukset-ui/src/vtj/stores/store.util'
import { InlineAlert, Paragraph } from 'suomifi-ui-components'
import LocalizedString from 'todistukset-ui/src/vtj/components/localized-string/LocalizedString.react'
import CertificateTypes from 'todistukset-common/src/vtj/CertificateTypes.enum'
import { shouldShowTranslationFormWithPreviousAddressesWarning } from 'todistukset-ui/src/vtj/stores/util/form.util'

type CertificateTypesProps = {
  certificateType: CertificateTypes
}

const StyledInlineAlert = styled(InlineAlert)`
  margin-top: ${({ theme }) => theme.spacing.m};

  & + .fi-checkbox_container {
    margin-top: ${({ theme }) => theme.spacing.m};
  }
`

export const TranslationFormWithPreviousAddressesInlineAlert: React.FC<CertificateTypesProps> =
  observer(({ certificateType }) => {
    const { t } = useTranslation()
    const {
      forms: { [certificateType]: form },
    } = useStore()

    const show = shouldShowTranslationFormWithPreviousAddressesWarning({
      certificateType: certificateType,
      form: form,
    })

    return show ? (
      <StyledInlineAlert
        ariaLiveMode="off"
        labelText={t('translationFormWithPreviousAddressesDialogTitle')}
        data-test-id="translation-form-with-previous-addresses-warning"
        status="warning"
      >
        <Paragraph>
          <LocalizedString stringKey="translationFormWithPreviousAddressesDialogContent" />
        </Paragraph>
      </StyledInlineAlert>
    ) : null
  })

export default TranslationFormWithPreviousAddressesInlineAlert
